function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import createPath from './createPath';
import ensureLocation from './ensureLocation';
function noop() {}
var ServerProtocol = /*#__PURE__*/function () {
  function ServerProtocol(url) {
    this._location = ensureLocation(url);
  }
  var _proto = ServerProtocol.prototype;
  _proto.init = function init() {
    return _extends({
      action: 'POP'
    }, this._location);
  };
  _proto.subscribe = function subscribe() {
    // Server protocol emits no events.
    return noop;
  };
  _proto.createHref = function createHref(location) {
    return createPath(location);
  } // The other methods are not implemented, because ServerProtocol instances
  // cannot navigate.
  ;

  return ServerProtocol;
}();
export { ServerProtocol as default };